/*
 * @Author: 李明明
 * @Date: 2023-03-02 09:00:04
 * @LastEditTime: 2023-12-21 09:20:18
 * @LastEditors: 李明明
 * @Description:
 * @FilePath: /ykt-micro-main/src/hooks/addClick.ts
 * 代码版权方：'政府采购信息网'
 */
import { ref } from "vue";
import router from "@/router/index";
import * as homeApi from "@/api/home.js";

const getQueryString = (url, name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = url.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

/**
 * @description: 点击广告
 * @param data: 广告相关数据
 * @return {*}
 */
const addClick = (data) => {
  console.log(data);
  const params = {
    id: data.id,
  };
  homeApi.addAdvertClickNumber(params).then((res) => {
    return res;
  });
  if (data.type == 3) {
    if (data.jumpUrl != "") {
      if (data.jumpUrl.indexOf("courseIds") != -1) {
        // `/shanxi_list` 页面已移除：保留原始行为，直接打开配置的跳转地址
        window.open(data.jumpUrl);
      } else {
        window.open(data.jumpUrl);
      }
    }
  } else {
    if (data.advertClickStatus == 1) {
      // 跳转研修班
      if (data.jumpType == 1) {
        router.push({
          path: "/sign_detail",
          query: {
            courseId: data.jumpYxbId,
          },
        });
      }
      // 跳转网页
      else if (data.jumpType == 2) {
        // 表单
        if (data.isForm == 1) {
          window.location.href = `${data.jumpUrl}`;
        }
        // 普通链接
        else {
          window.open(data.jumpUrl);
        }
      }
    }
  }
};

export { addClick };
